module.exports = __webpack_public_path__ + "img/img_mobile_select_quan.a6674c48.png";